// extracted by mini-css-extract-plugin
export var alt = "FeaturesTabsCity-module--alt--a22ad";
export var desktopOnly = "FeaturesTabsCity-module--desktopOnly--a40c6";
export var main = "FeaturesTabsCity-module--main--9b904";
export var mobileOnly = "FeaturesTabsCity-module--mobileOnly--ed117";
export var styledNav = "FeaturesTabsCity-module--styledNav--a8dda";
export var styledRow = "FeaturesTabsCity-module--styledRow--c4459";
export var styledTabPanes = "FeaturesTabsCity-module--styledTabPanes--be2b9";
export var textLeft = "FeaturesTabsCity-module--textLeft--e87f3";
export var visuallyHidden = "FeaturesTabsCity-module--visuallyHidden--ad846";